(function CancelPreview($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$('#cancellation-refund-amount').val('full_refund');
		$('#refunds').hide();
		$('#refund_tracking').hide();

		$('#do_not_submit_to_provider').on('change', function setSubmitToProvider(e) {
			if ($('#do_not_submit_to_provider').is(':checked')) {
				$('#refunds').show();
				$('#refund_tracking').show();
				$('#cancellation-notes').attr('required', true);

			} else {
				$('#refunds').hide();
				$('#refund_tracking').hide();
				$('#refund-amount-block').hide();
				$('#cancellation-notes').attr('required', false);

				$('#refunds').val('full');
				$('#cancellation-refund-amount').val('full_refund');
			}

			// need to show/hide submit button in some circumstances
			if ($('#yes-submit').hasClass('conditional')) {
				$('#yes-submit').toggleClass('d-none');
			}
		});

		$('#refunds').on('change', function hideAmount(e) {
			if ($('#refunds').val() === 'partial') {
				$('#cancellation-refund-amount').val('');
				$('#refund-amount-block').show();
			} else if ($('#refunds').val() === 'full') {
				$('#cancellation-refund-amount').val('full_refund');
				$('#refund-amount-block').hide();
			} else if ($('#refunds').val() === 'norefund') {
				$('#cancellation-refund-amount').val('no_refund');
				$('#refund-amount-block').hide();
			}
		});

		HE.onload('/Reservations/cancelPreview/', function onload()
		{
			$('#refund-amount-block').hide();
		});
	});
}(jQuery, window.HE || {}));
